import React from "react";
import PropTypes from "prop-types";
import { SortableContainer } from "react-sortable-hoc";
import SortableOption from "@Features/ChatsBots/components/SortableOption";

const SortableOptionsList = SortableContainer(
	({ options, stageId, stages, stage, updateOption, isRemove, errors, moveOption, modalOption, actionsList }) => {
		return (
			<div>
				{options.map((option, index) => {
					return (
						<SortableOption
							key={`option-${option.id}`}
							index={index}
							pocition={index}
							option={option}
							stageId={stageId}
							updateOption={updateOption}
							isRemove={isRemove}
							stages={stages}
							stage={stage}
							errors={errors}
							moveOption={moveOption}
							optionsLength={options.length}
							modalOption={modalOption}
							actionsList={actionsList}
						/>
					);
				})}
			</div>
		);
	}
);

SortableOptionsList.propTypes = {
	options: PropTypes.array.isRequired,
	stageId: PropTypes.number.isRequired,
	updateOption: PropTypes.func.isRequired,
	isRemove: PropTypes.func.isRequired,
	stage: PropTypes.object.isRequired,
	stages: PropTypes.array.isRequired,
	errors: PropTypes.object,
	moveOption: PropTypes.func.isRequired,
	optionsLength: PropTypes.number.isRequired,
	modalOption: PropTypes.string,
	actionsList: PropTypes.object,
};

export default SortableOptionsList;
